<div class="ai-in-line-control-page">
  @if (isLoading()) {
    <div class="policy-spinner">
      <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
    </div>
  }

  <div class="page-header">
    <div class="subtitle">
      <span [innerHTML]="inLineControlSubtitlePath | labelsProvider"></span>
    </div>
  </div>

  @if (isLoading() === false) {
    <div class="scollable-tables">
      @if (isAccountAuthorizedToViewDataInLineControl) {
        <div class="table-actions">
          @if (pageFilters()) {
            <app-in-line-control-filters
              class="full-width"
              [pageFilters]="pageFilters()!"
            ></app-in-line-control-filters>
          }
        </div>

        <div class="table-header">
          <div class="resources-amount">
            {{ 'common.found' | labelsProvider }} {{ totalItems() > -1 ? (totalItems() | number) : 0 }}
            {{ 'enterpriseAiDetectionPage.tabs.inLineControl' | labelsProvider }}
          </div>
        </div>

        <div class="table">
          @if (pageFilters()) {
            <app-in-line-control-vertical-filters
              [ngClass]="{ 'filters-all': isFiltersMenuOpen() }"
              (optionOnSelection)="tablesFiltersChange($event)"
              [pageFilters]="pageFilters()!"
              [isFiltersMenuOpen]="isFiltersMenuOpen()"
              (filtersOnMenuStateChange)="isFiltersMenuOpen.set($event)"
            />
          }

          <app-enterprise-ai-in-line-control
            [integration]="integration()"
            [ngClass]="!isFiltersMenuOpen() ? 'table-collapsed-menu' : 'table-component'"
            (totalItems)="onTotalItemsChange($event)"
          ></app-enterprise-ai-in-line-control>
        </div>
      } @else {
        <div class="unauthorized-access">
          <p>You don't have access to view this page.</p>
        </div>
      }
    </div>
  }
</div>
